<template>
  <div class="container">
    <div class="top">授权微脉输入法</div>
    <img class="logo" src="https://imagessl.lingtuo.cn/A-1ed71af7_20241111151509.png" />
    <p class="desc">
      前往系统设置<br>
      隐私与安全性 → 辅助功能<br>
      添加并打开 微脉输入法
    </p>
    <div class="btn-area">
      <button
        class="auth-btn"
        :disabled="status === 'requesting' || status === 'done'"
        @click="tryAuth"
      >{{ btnText }}</button>
    </div>
  </div>
</template>

<script>
const { ipcRenderer } = window.require("electron");

export default {
  name: "AuthGuide",
  data() {
    return {
      status: "idle", // idle | requesting | done | error
      errorMsg: "",
      _pollTimer: null,
    };
  },
  computed: {
    btnText() {
      switch (this.status) {
        case "requesting": return "授权中…";
        case "done": return "已授权 ✓";
        default: return "授权辅助功能权限";
      }
    },
    statusText() {
      switch (this.status) {
        case "idle": return "请点击按钮授权";
        case "requesting": return "正在拉起系统授权对话框…";
        case "done": return "已授权，正在进入…";
        case "error": return this.errorMsg || "授权失败，请手动前往系统设置";
        default: return "";
      }
    },
  },
  mounted() {
    this.checkAndPoll();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    async tryAuth() {
      this.status = "requesting";
      this.errorMsg = "";
      try {
        const result = await ipcRenderer.invoke("auth-try");
        if (result.ok) {
          this.status = "done";
          this.bootstrapApp();
        } else {
          this.status = "error";
          this.errorMsg = result.error || "授权失败";
        }
      } catch (e) {
        this.status = "error";
        this.errorMsg = e.message || "授权失败";
      }
    },
    async checkAndPoll() {
      // 先做一次即时检测
      try {
        const trusted = await ipcRenderer.invoke("auth-check");
        if (trusted) {
          this.status = "done";
          this.bootstrapApp();
          return;
        }
      } catch (_) {}
      // 每 2s 轮询
      this._pollTimer = setInterval(async () => {
        try {
          const trusted = await ipcRenderer.invoke("auth-check");
          if (trusted) {
            this.status = "done";
            this.stopPolling();
            this.bootstrapApp();
          }
        } catch (_) {}
      }, 2000);
    },
    async bootstrapApp() {
      setTimeout(async () => {
        try { await ipcRenderer.invoke("auth-all-done"); } catch (_) {}
      }, 800);
    },
    stopPolling() {
      if (this._pollTimer) {
        clearInterval(this._pollTimer);
        this._pollTimer = null;
      }
    },
  },
};
</script>

<style scoped>
.container {
  text-align: center;
}

.top {
  padding-top: 56px;
  color: #353535;
  font-size: 20px;
}

.logo {
  width: 80px;
  height: 80px;
  margin: auto;
  margin-top: 24px;
  display: block;
}

.desc {
  margin-top: 40px;
  text-align: center;
  line-height: 25px;
  font-size: 14px;
}

.btn-area {
  margin-top: 28px;
  text-align: center;
}

.auth-btn {
  padding: 8px 24px;
  font-size: 14px;
  border: 1px solid #FF6058;
  background: #FF6058;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.auth-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.auth-btn:not(:disabled):hover {
  background: #e5554e;
}

.status-text {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}

.status-text.error {
  color: #FF6058;
}

.status-text.done {
  color: #52c41a;
}
</style>
